import { BrowserRouter as Router } from "react-router-dom";
import Nav from "./components/nav";
import AnimatedRoutes from "./components/AnimatedRoutes";

function App() {
  return (
    <>
      <Router>
        <main className="App bg-black text-white min-w-screen min-h-screen relative">
          <Nav />
          <AnimatedRoutes />
        </main>
      </Router>
    </>
  );
}

export default App;
